import { action, Action, thunk, Thunk } from 'easy-peasy';
import { cloneDeep } from 'lodash';
import { MaterialTopicItem } from '@/services/material/index.d';

export interface IMaterialCollapse {
    // 常用素材列表
    recentUsedList: MaterialTopicItem | null;
    // 常用背景列表
    recentBGUsedList: MaterialTopicItem | null;
    recentTextUsedList: MaterialTopicItem | null;
    setRecentTextUsedList: Action<IMaterialCollapse, MaterialTopicItem | null>;
    setRecentBGUsedList: Action<IMaterialCollapse, MaterialTopicItem | null>;
    setRecentUsedList: Action<IMaterialCollapse, MaterialTopicItem | null>;
    getRecentUsedList: Thunk<IMaterialCollapse>;
    // 常用水印列表
    recentWatermarkUsedList: MaterialTopicItem | null;
    setRecentWatermarkUsedList: Action<IMaterialCollapse, MaterialTopicItem | null>;
}

export const materialCollapseModel: IMaterialCollapse = {
    recentUsedList: null,
    recentBGUsedList: null,
    recentTextUsedList: null,
    recentWatermarkUsedList: null,
    setRecentTextUsedList: action((state, list) => {
        state.recentTextUsedList = cloneDeep(list);
    }),
    setRecentBGUsedList: action((state, list) => {
        state.recentBGUsedList = cloneDeep(list);
    }),
    setRecentUsedList: action((state, list) => {
        state.recentUsedList = cloneDeep(list);
    }),
    getRecentUsedList: thunk((actions, payload, state) => {
        return state.getState().recentUsedList;
    }),
    setRecentWatermarkUsedList: action((state, list) => {
        state.recentWatermarkUsedList = cloneDeep(list);
    }),
};
